import axios from "axios";
import * as qs from 'qs'

export default function () {
  const token = (document.querySelector('meta[name=csrf-token]') || {})['content'];
  if (token) {
    axios.defaults.headers['X-CSRF-TOKEN'] = token;
  }

  axios.defaults.paramsSerializer = function (params) {
    return qs.stringify(params, {arrayFormat: 'brackets'})
  }

  return axios;
}
